$(document).ready(function() {
  $('.offer_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 3000,
    // variableWidth: true
  });

  // Accordian
  $(document).on('click','.cust-accordion .acco-title',function(e) {
    e.preventDefault();
    $(this).toggleClass('active').siblings('.acco-content').slideToggle();
    // $('.discount-code-desc-main.slick-slide').slick('refresh');
  })

  var $status = $('.sliderInfo');
  var $slickElement = $('.offer_slider');

  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
  });

  $('.codecopy-loader').hide();
    $(document).on('click', 'div.discount-code-snippet .discount-code', function(e) {
        e.preventDefault();
        var current = $(this).siblings('.discount-success-msg');
        var curr = $(this).children('span');
        var discount_code = $(this).data('id');
        var loaderclass = $(this).siblings('.codecopy-loader');
        $.ajax({
            url: `/discount/${discount_code}`,
            method: 'GET',
            beforeSend: function() {
                $(loaderclass).show();
                $(current).hide();
            },
            success: function() {
                $(loaderclass).hide();
                $(current).show();
                $(current).html('Code applied');
                $(curr).removeClass('before-apply');
                $(curr).addClass('after-apply');
            }
        })
    });
});

const ratingHeight = () =>  {
  let cacheHeight = 0;
  setTimeout(() => {
    let ele = document.querySelectorAll('.grid-view-item .grid-view-item__title');
    if(ele){
      ele.forEach(element => {
        (element.clientHeight > cacheHeight) ? cacheHeight = element.clientHeight : cacheHeight = cacheHeight;
      });
      ele.forEach(element => {
        element.style.height = `${cacheHeight}px`
      })
    }
  
  }, 1000);
 }
 

 document.addEventListener('DOMContentLoaded', () => {
  ratingHeight();
 })